import { MeasureLingette } from '../../domain/Lingette/measure-lingette';
import { mapper } from '../../tools/mapping/mapper';
import { MeasureLingetteEntity } from '../entity';
import type { AppDB } from '../db';

export class MeasureLingetteRepository {
    constructor(private readonly database: AppDB) {}


    async getMeasureLingetteEntityByCode(code: string) {
        return await this.database.measureLingette.where('Code').equals(code).first(async mle => {
            return mle;
        });
    }

    async getMeasureLingetteById(id: number) {
        return await this.database.measureLingette.where('Id').equals(id).first(async mle => {
            const ml = mapper.map(mle, MeasureLingetteEntity, MeasureLingette);
            return ml;
        });
    }

    async getMeasureLingetteByCode(code: string) {
        return await this.database.measureLingette.where('Code').equals(code).first(async mme => {
            const me = mapper.map(mme, MeasureLingetteEntity, MeasureLingette);
            return me;
        });
    }

    async attachMeasureLingette(measure: MeasureLingette, interventionId: number) {
        let lingetteId: number;
        const mme = mapper.map(measure, MeasureLingette, MeasureLingetteEntity);

        const ie = await this.database.getInterventionEntityById(interventionId);
        lingetteId = await this.database.measureLingette.add(mme);
        await this.database.interventions.update(interventionId, {
            LingetteIds: ie?.LingetteIds ? [...ie.LingetteIds, lingetteId] : [lingetteId]
        });

        return lingetteId;
    }

    async updateMeasureLingette(measure: MeasureLingette) {
        const mle = await this.database.getMeasureLingetteEntityByCode(measure.Code);
        if (!mle || !mle.Id) {
            return false;
        }
        mapper.mutate(measure, mle, MeasureLingette, MeasureLingetteEntity);
        await this.database.measureLingette.update(mle.Id, mle);

        return true;
    }

    async cancelLingette(measure: MeasureLingette, reason: string) {
        const mle = await this.database.getMeasureLingetteEntityByCode(measure.Code);
        if (!mle || !mle.Id) {
            return;
        }

        await this.database.measureLingette.update(mle.Id, { IsCancelled: true, Observation: reason });
        return true;
    }
}
